module.exports = __webpack_public_path__ + "static/media/alert-empty.19fbda8a.svg";